import { Chip, Stack, Typography } from "@mui/material";
import styles from "./TabLabel.module.css"

type TabLabelProp = {
	text: string;
	count: number;
};

export default function TabLabel({ text, count }: TabLabelProp) {
	const countLabel = count > 99 ? "99+" : count.toString();
	return (
		<Stack direction="row" spacing="8px" alignItems="center">
			<Typography className={styles.label}>{text}</Typography>
			<Chip label={countLabel} sx={{ borderRadius: "2px", backgroundColor: "rgb(249,249,249)" }} />
		</Stack>
	);
}
